import React from 'react';
import { 
  AccumulationChartComponent, 
  AccumulationSeriesCollectionDirective, 
  AccumulationSeriesDirective, 
  AccumulationLegend, 
  PyramidSeries, 
  AccumulationDataLabel, 
  AccumulationTooltip, 
  Inject } from '@syncfusion/ej2-react-charts';

  import { PyramidData } from '../../Data/dummy';
  import { ChartsHeader } from '../../components';
  import { useStateContext } from '../../context/ContextProvider';

const Pyramid = () => {
  const { currentMode } = useStateContext();
  return (
    <div className='m-4 md:m-10 mt-24 p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl'>
      <ChartsHeader category='Pyramid' title='Food Comparison Chart' />
      <div className="w-full">
      <AccumulationChartComponent
      id='charts'
      background = { currentMode === 'Dark' ? '#33373E' : '#FFFFFF' }
      tooltip= {{ enable: true }}
      legendSettings={{ background: 'white' }}
    >
      <Inject services={[PyramidSeries, AccumulationLegend, AccumulationDataLabel, AccumulationTooltip]} />
      <AccumulationSeriesCollectionDirective>
        <AccumulationSeriesDirective 
          name="Sale"
          dataSource={PyramidData}
          xName="x"
          yName="y"
          type='Pyramid'
          width='45%'
          height='80%'
          neckWidth='15%'
          gapRatio={0.03}
          explode
          emptyPointSettings={{ mode:'Drop', fill:'red' }}
          dataLabel={{
            visible: true,
            position: 'Inside',
            name: 'text'
          }}
        />
      </AccumulationSeriesCollectionDirective>

    </AccumulationChartComponent>
      </div>

    </div>
  )
}

export default Pyramid